import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { Place } from '@/_types/places';

/* ------------- Types and Action Creators ------------- */

interface SelectedPlaceInfos {
  placeId: string;
  placeName: string;
  placeAvatarSrc: string;
}

interface PlacesState {
  placeSelectedToEdit: Place | null;
  placeSelectedToViewRules: SelectedPlaceInfos | null;
}

const initialState: PlacesState = {
  placeSelectedToEdit: null,
  placeSelectedToViewRules: null,
};

const placesSlice = createSlice({
  name: 'places',
  initialState,
  reducers: {
    setPlaceSelectedToEdit: (state, action: PayloadAction<Place>) => {
      state.placeSelectedToEdit = action.payload;
    },
    setSelectedPlaceToViewRules: (
      state,
      action: PayloadAction<SelectedPlaceInfos | null>,
    ) => {
      state.placeSelectedToViewRules = action.payload;
    },
  },
});

export const { setPlaceSelectedToEdit, setSelectedPlaceToViewRules } =
  placesSlice.actions;

export const placesReducer = placesSlice.reducer;
